const SENEGAL_PREFIXES = new Set(["70", "75", "76", "77", "78"]);

function stripPhoneFormatting(value: string) {
  return value.replace(/[^\d+]/g, "").trim();
}

export function extractSenegalPhoneDigits(value: string) {
  const trimmed = stripPhoneFormatting(value);

  if (trimmed.startsWith("+221")) {
    return trimmed.slice(4).replace(/\D/g, "").slice(0, 9);
  }

  if (trimmed.startsWith("221")) {
    return trimmed.slice(3).replace(/\D/g, "").slice(0, 9);
  }

  return trimmed.replace(/\D/g, "").slice(0, 9);
}

export function isValidSenegalPhoneDigits(value: string) {
  return /^\d{9}$/.test(value) && SENEGAL_PREFIXES.has(value.slice(0, 2));
}

export function getSenegalPhoneError(value: string) {
  if (!value.trim()) {
    return "Le numero de telephone est obligatoire.";
  }

  const digits = extractSenegalPhoneDigits(value);

  if (!/^\d{9}$/.test(digits)) {
    return "Le numero doit contenir 9 chiffres apres +221.";
  }

  if (!SENEGAL_PREFIXES.has(digits.slice(0, 2))) {
    return "Le numero doit commencer par 70, 75, 76, 77 ou 78.";
  }

  return undefined;
}

export function toSenegalPhoneE164(value: string) {
  const digits = extractSenegalPhoneDigits(value);
  return `+221${digits}`;
}
